// WhatsApp message templates per language.
// Placeholders: {title}, {hectares}, {location}. Each falls back gracefully if missing.

const WITH_ALL = {
  es: 'Hola, me interesa la propiedad "{title}" de {hectares} ubicada en la zona {location}. Quisiera más información.',
  pt: 'Olá, tenho interesse no imóvel "{title}" de {hectares} localizado na zona {location}. Gostaria de mais informações.',
  en: 'Hello, I\'m interested in the "{title}" property of {hectares} located in {location}. I\'d like more information.',
  de: 'Hallo, ich interessiere mich für die Immobilie "{title}" von {hectares} in der Region {location}. Ich hätte gerne mehr Informationen.',
  fr: 'Bonjour, je suis intéressé(e) par la propriété "{title}" de {hectares} située dans la zone {location}. Je souhaiterais plus d\'informations.',
};

const WITH_TITLE_LOC = {
  es: 'Hola, me interesa la propiedad "{title}" ubicada en la zona {location}. Quisiera más información.',
  pt: 'Olá, tenho interesse no imóvel "{title}" localizado na zona {location}. Gostaria de mais informações.',
  en: 'Hello, I\'m interested in the "{title}" property located in {location}. I\'d like more information.',
  de: 'Hallo, ich interessiere mich für die Immobilie "{title}" in der Region {location}. Ich hätte gerne mehr Informationen.',
  fr: 'Bonjour, je suis intéressé(e) par la propriété "{title}" située dans la zone {location}. Je souhaiterais plus d\'informations.',
};

const WITH_TITLE_HA = {
  es: 'Hola, me interesa la propiedad "{title}" de {hectares}. Quisiera más información.',
  pt: 'Olá, tenho interesse no imóvel "{title}" de {hectares}. Gostaria de mais informações.',
  en: 'Hello, I\'m interested in the "{title}" property of {hectares}. I\'d like more information.',
  de: 'Hallo, ich interessiere mich für die Immobilie "{title}" von {hectares}. Ich hätte gerne mehr Informationen.',
  fr: 'Bonjour, je suis intéressé(e) par la propriété "{title}" de {hectares}. Je souhaiterais plus d\'informations.',
};

const WITH_TITLE_ONLY = {
  es: 'Hola, me interesa la propiedad "{title}". Quisiera más información.',
  pt: 'Olá, tenho interesse no imóvel "{title}". Gostaria de mais informações.',
  en: 'Hello, I\'m interested in the "{title}" property. I\'d like more information.',
  de: 'Hallo, ich interessiere mich für die Immobilie "{title}". Ich hätte gerne mehr Informationen.',
  fr: 'Bonjour, je suis intéressé(e) par la propriété "{title}". Je souhaiterais plus d\'informations.',
};

const DEFAULT = {
  es: "Hola, quisiera más información sobre las propiedades de ImpecLand.",
  pt: "Olá, gostaria de mais informações sobre os imóveis da ImpecLand.",
  en: "Hello, I'd like more information about ImpecLand's properties.",
  de: "Hallo, ich hätte gerne mehr Informationen über die Immobilien von ImpecLand.",
  fr: "Bonjour, je souhaiterais plus d'informations sur les biens d'ImpecLand.",
};

const pick = (table, lang) => table[lang] || table.es;

export const buildWhatsAppMessage = ({ lang = "es", property = null, url = "" }) => {
  if (!property) return pick(DEFAULT, lang);

  const title = (property.title || "").trim();
  const hectares = (property.hectares || "").trim();
  const location = (property.location || "").trim();

  let template;
  if (title && hectares && location) template = pick(WITH_ALL, lang);
  else if (title && location) template = pick(WITH_TITLE_LOC, lang);
  else if (title && hectares) template = pick(WITH_TITLE_HA, lang);
  else if (title) template = pick(WITH_TITLE_ONLY, lang);
  else return pick(DEFAULT, lang);

  let msg = template
    .replace("{title}", title)
    .replace("{hectares}", hectares)
    .replace("{location}", location);
  if (url) msg += `\n${url}`;
  return msg;
};
